import styled from 'styled-components';

interface SimpleDivisorProps {
  margin: number;
}

const SimpleDivisor = styled.div<SimpleDivisorProps>`
  display: block;
  margin: ${(props) => props.margin}px 0;
  border: 1px solid #cdcdcd;
`;

export default SimpleDivisor;
